import { render } from "./pay-processing.vue?vue&type=template&id=2f9d9ce6"
import script from "./pay-processing.vue?vue&type=script&lang=js"
export * from "./pay-processing.vue?vue&type=script&lang=js"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__